import { render } from "./StayConectedWith.vue?vue&type=template&id=2feb1c31&scoped=true"
import script from "./StayConectedWith.vue?vue&type=script&lang=js"
export * from "./StayConectedWith.vue?vue&type=script&lang=js"

import "./StayConectedWith.vue?vue&type=style&index=0&id=2feb1c31&scoped=true&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2feb1c31"]])

export default __exports__